/**
 * How a risk score reads.
 *
 * Risk is scored 0–10 and the same four bands — Low, Medium, High, Critical —
 * appear on the Risk Management list, on a profile's own page, and in the
 * component-risk bars. These lived on the list page, which meant the detail
 * page had to import from it; a score's meaning belongs to neither.
 */

const CRITICAL = 8;
const HIGH = 6;
const MEDIUM = 4;

export function getRiskBadgeVariant(
  risk: number
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (risk >= CRITICAL) return 'destructive';
  if (risk >= HIGH) return 'default';
  if (risk >= MEDIUM) return 'secondary';
  return 'outline';
}

export function getRiskLabel(risk: number): string {
  if (risk >= CRITICAL) return 'Critical';
  if (risk >= HIGH) return 'High';
  if (risk >= MEDIUM) return 'Medium';
  return 'Low';
}

export function getRiskColor(risk: number): string {
  if (risk >= CRITICAL) return 'text-red-600 bg-red-100';
  if (risk >= HIGH) return 'text-orange-600 bg-orange-100';
  if (risk >= MEDIUM) return 'text-yellow-600 bg-yellow-100';
  return 'text-green-600 bg-green-100';
}

/** The bar colour for one component risk, on the shared status palette. */
export function getRiskBarClass(risk: number): string {
  if (risk >= CRITICAL) return 'bg-status-destructive';
  if (risk >= HIGH) return 'bg-status-warning';
  if (risk >= MEDIUM) return 'bg-status-info';
  return 'bg-status-success';
}
